module.exports = __webpack_public_path__ + "static/media/log-viewer.cd36e105.svg";